export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    selectItems({commit}, item) {
        commit('selectItems', item)
    },
    deleteItem({commit}, index) {
        commit('deleteItem', index)
    },
    deleteSelectedItems({commit}, index) {
        commit('deleteSelectedItems', index)
    }
}
